import { render } from "./uploadImage.vue?vue&type=template&id=10fd8612&scoped=true"
import script from "./uploadImage.vue?vue&type=script&lang=js"
export * from "./uploadImage.vue?vue&type=script&lang=js"

import "./uploadImage.vue?vue&type=style&index=0&id=10fd8612&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fd8612"]])

export default __exports__